import React from 'react';
import { Card, Table } from 'antd';
import KeywordResearchSuggestionsButton from './suggestions/KeywordResearchSuggestionsButton';
import ReportCardTitle from '../components/shared/ReportCardTitle/ReportCardTitle';
import TopKeywordsResults from '../topKeywords/TopKeywordsResults';
import { defaultOrderBy, defaultOrderDir } from '../topKeywords/settings';
import { TopKeywordsTableRecord } from '../topKeywords/types';
import useGetCurrentWebsite from '../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite';
import './KeywordResearch.less';


const { Column } = Table;


export default function KeywordResearch() {
    const { website: selectedWebsite } = useGetCurrentWebsite();

    if (!selectedWebsite) {
        return null;
    }

    const websiteGuid = selectedWebsite.guid;
    const domain = selectedWebsite.domain;
    const locationName = selectedWebsite.settings.location_name || 'United States';
    const languageCode = selectedWebsite.settings.language_code || 'en';

    return (
        <Card
            data-cy="keywords-research-table"
            title={
                <ReportCardTitle
                    title="Keyword Research"
                    domain={selectedWebsite.domain}
                />
            }
        >
            <TopKeywordsResults
                key={`${websiteGuid}_${locationName}_${languageCode}`}
                domain={domain}
                locationName={locationName}
                languageCode={languageCode}
                orderBy={defaultOrderBy}
                orderDir={defaultOrderDir}
                extraColumn={
                    <Column
                        className="al-center no-wrap"
                        title="Suggestions"
                        dataIndex="suggestions"
                        render={(text, record: TopKeywordsTableRecord, index) => (
                            <KeywordResearchSuggestionsButton
                                keyword={record.keyword}
                                location={locationName}
                                languageCode={languageCode}
                            />
                        )}
                    />
                }
            />
        </Card>
    );
}
